module.exports = __webpack_public_path__ + "img/img11.becd362b.svg";